<script>
import removeSpecialChars from "@utils/remove-special-chars";
import keysToCamel from "@utils/keys-to-camel";
import getUtms from "@utils/get-utms";
import getUtmsAndAdditionalData from "@utils/get-utms-and-additional-data";
import getAdditionalData from "@utils/get-additional-data";
export default {
  name: "consultaCoberturaProvider",
  provide: {
    fetchData() {
      const store = {
        telefone: this.$store.getters["order/getLeadTelefone"],
      };
      const newData = Object.keys(this.data).reduce(
        (prev, field) => ({
          ...prev,
          [field]: store[field] || "",
        }),
        { ...this.data }
      );
      this.data = newData;
      return;
    },
    async handleSubmit() {
      const $this = this;
      const { data } = $this;
      const queries = $this.$store.getters["getQuery"];
      let utm = keysToCamel(getUtms(getUtmsAndAdditionalData(queries)));
      utm = { ...utm, ...keysToCamel(getAdditionalData(queries)) };
      const payload = {
        tipoProjeto: "FixaB2B",

        telefone: removeSpecialChars(data.telefone),
        cep: removeSpecialChars(data.cep),
        numero: data.numero,
        utm: {
          ...utm,
          dadosAdicionais: {
            ...utm.dadosAdicionais,
            leadSource: data.leadSource,
            vendedor: data.vendedor,
          },
        },
        idSession: $this.$store.getters["order/getIdSessionOFDB"],
        produto: queries.dadosAdicionais.sku
          ? {
              fixa: {
                tipoProduto: "VIVO FIBRA",
                sku: queries.dadosAdicionais.sku,
                anual: "TRUE",
              },
            }
          : null,
      };

      await Orchestrator();

      // funções
      // eslint-disable-next-line no-unused-vars
      async function Orchestrator() {
        try {
          $this.generalError = false;
          $this.$store.dispatch("order/setPersonalData", payload);

          // await $this
          //   .formUtils()
          //   .fetch.call($this, "catalog", "getJson", {}, response => {
          //     saveCatalog.call($this, response.portfolio);
          //   });

          await $this
            .formUtils()
            .fetch.call(
              $this,
              "api",
              "ConsultarViabilidade",
              payload,
              response => {
                if (response.error) {
                  throw new Error("Erro de timeout excedido.");
                }
                if (response.sucesso) {
                  const endereco = {
                    localidade: response.endereco.cidade,
                    numero: response.endereco.numImovel,
                    uf: response.endereco.estado,
                  };
                  saveOrderId.call($this, response.identificadorPedido);
                  saveOffer.call($this, response.oferta);
                  saveAddress.call($this, {
                    ...response.endereco,
                    ...endereco,
                  });
                  saveCatalog.call($this, { fixa: response.catalogo });
                  $this.$store.dispatch(
                    "order/setBillConfig",
                    response.configuracoes
                  );
                  response.catalogo.length <= 1
                    ? $this
                        .formUtils()
                        .goToNextPage.call(
                          $this,
                          `/${response.catalogo[0].info_plano.tipo_plano.toLowerCase()}${response.urlRedirect.toLowerCase()}`
                        )
                    : $this
                        .formUtils()
                        .goToNextPage.call(
                          $this,
                          response.urlRedirect.toLowerCase()
                        );
                } else {
                  if (!response.endereco) {
                    $this.generalError = true;
                    $this.messageError = response.mensagem;
                  }
                }
              }
            );
        } catch (error) {
          $this.generalError = true;
        }
      }

      function saveAddress(endereco) {
        this.$store.dispatch("order/setAddress", endereco);
      }
      function saveCatalog(portfolio) {
        this.$store.dispatch("catalog/setCatalog", { portfolio });
      }
      function saveOffer(oferta) {
        this.$store.dispatch("catalog/setOffer", oferta);
      }
      function saveOrderId(identificadorPedido) {
        this.$store.dispatch("order/setOrderId", identificadorPedido);
      }
    },
  },
  render() {
    return this.$slots.default;
  },
};
</script>
